import React from 'react';
import Tour from 'reactour';
import TextSelectionGif from '../assets/text-tool.gif';
import FreeformGif from '../assets/freeform-tool.gif';

var StepTour = function StepTour(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
    className: "font-bold mb-2"
  }, title), description && /*#__PURE__*/React.createElement("div", {
    className: "text-gray-700"
  }, description), children && children);
};

var steps = [{
  selector: '#time-to-left',
  content: /*#__PURE__*/React.createElement(StepTour, {
    title: "Timer",
    description: "You have 30 minutes in your redactor session before your document is securely removed. Make your changes and download the file before the timer runs out."
  })
}, {
  selector: '#tool-text-btn',
  content: /*#__PURE__*/React.createElement(StepTour, {
    title: "Tools"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-700"
  }, "Text tool"), /*#__PURE__*/React.createElement("div", {
    className: "text-sm text-gray-500"
  }, "(default)"), /*#__PURE__*/React.createElement("img", {
    className: "mt-2 border-2 rounded",
    style: {
      width: 300,
      height: 200
    },
    src: TextSelectionGif,
    alt: "tip"
  }))
}, {
  selector: '#tool-freeform-btn',
  content: /*#__PURE__*/React.createElement(StepTour, {
    title: "Tools"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-700"
  }, "Freeform Tool"), /*#__PURE__*/React.createElement("img", {
    className: "mt-2 border-2 rounded",
    style: {
      width: 300,
      height: 200
    },
    src: FreeformGif,
    alt: "tip"
  }))
}];

var EditorTour = function EditorTour(_ref2) {
  var isTourOpen = _ref2.isTourOpen,
      toggleIsTourOpen = _ref2.toggleIsTourOpen;
  return isTourOpen && /*#__PURE__*/React.createElement(Tour, {
    steps: steps,
    isOpen: isTourOpen,
    onRequestClose: toggleIsTourOpen,
    prevButton: /*#__PURE__*/React.createElement("div", {
      className: "h-8 bg-gray-300 hover:bg-gray-400 font-bold py-2 px-4 rounded inline-flex items-center text-white bg-primary hover:bg-secondary focus:outline-none"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "15",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10 19l-7-7m0 0l7-7m-7 7h18"
    }))),
    nextButton: /*#__PURE__*/React.createElement("div", {
      className: "h-8 bg-gray-300 hover:bg-gray-400 font-bold py-2 px-4 rounded inline-flex items-center text-white bg-primary hover:bg-secondary focus:outline-none"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "15",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, /*#__PURE__*/React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M14 5l7 7m0 0l-7 7m7-7H3"
    }))),
    lastStepNextButton: /*#__PURE__*/React.createElement("div", {
      className: "h-8 bg-gray-300 hover:bg-gray-400 font-bold py-2 px-4 rounded inline-flex items-center text-white bg-primary hover:bg-secondary focus:outline-none"
    }, "OK")
  });
};

export default EditorTour;